import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { themeLss } from "../../lss";
import styled from "../../styled";
export var Text = styled.span(themeLss({
  textScale: 'content'
}));
var BaseHeading = styled.span(themeLss({
  m: 0
}));
export var H1 = styled(BaseHeading).attrs({
  as: 'h1'
})(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.heading1;
});
export var H2 = styled(BaseHeading).attrs({
  as: 'h2'
})(function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.heading2;
});
export var H3 = styled(BaseHeading).attrs({
  as: 'h3'
})(function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.heading3;
});
export var H4 = styled(BaseHeading).attrs({
  as: 'h4'
})(function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.heading4;
});
export var H5 = styled(BaseHeading).attrs({
  as: 'h5'
})(function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.heading5;
});
export var H6 = styled(BaseHeading).attrs({
  as: 'h6'
})(function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.heading6;
});
/**
 * Renders the children when it's a string
 * otherwise render it as Text with the provided props
 */

export var TextOrNode = function TextOrNode(_ref7) {
  var children = _ref7.children,
      otherProps = _objectWithoutProperties(_ref7, ["children"]);

  if (typeof children === 'string') {
    return React.createElement(Text, Object.assign({}, otherProps), children);
  } // had to use a fragment to make TS interpret the null, undefined, {} and number children


  return React.createElement(React.Fragment, null, children);
};